var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-page-content-wrapper features" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("message.availability"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.$t("fastWizard.onlineSupportVisitorTime"))),
      ]),
    ]),
    _vm._v(" "),
    _c("section", [
      _c("div", { staticClass: "features" }, [
        _c("div", { staticClass: "feature no-background" }, [
          _c(
            "div",
            [
              _c(
                "a-row",
                { attrs: { type: "flex", justify: "center", align: "top" } },
                [
                  _c(
                    "a-col",
                    { staticClass: "mt-3 mb-3" },
                    [
                      _c("AvailabilityConfig"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "offline-button" },
                        [
                          _c("FeatureItem", {
                            attrs: {
                              title: _vm.$t("message.offlineMode"),
                              description: _vm.$t("message.vtipyOfflineMode"),
                              icon: "offlineIcon",
                            },
                            model: {
                              value: _vm.offlineMode,
                              callback: function ($$v) {
                                _vm.offlineMode = $$v
                              },
                              expression: "offlineMode",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "a-col",
                            { staticClass: "mt-5 my-auto p-3" },
                            [
                              _c(
                                "a-button",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                      },
                                      expression:
                                        "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                        }",
                                    },
                                  ],
                                  staticClass: "custom-field-button btnColor",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    content: _vm.$t("message.tooltipOSRForm"),
                                    danger: "",
                                    ghost: "",
                                  },
                                  on: { click: _vm.showModal },
                                  model: {
                                    value: _vm.editMode,
                                    callback: function ($$v) {
                                      _vm.editMode = $$v
                                    },
                                    expression: "editMode",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.changeOSRForm")) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.isModalShow
                                ? _c(
                                    "Modal2",
                                    {
                                      attrs: {
                                        "show-footer": false,
                                        id: "osr-form",
                                        title: _vm.editMode
                                          ? _vm.$t("message.updateOSRForm")
                                          : _vm.$t("message.newOSRForm"),
                                      },
                                      on: { cancel: _vm.hideModal },
                                    },
                                    [
                                      _vm.$validator.errors.items.length &&
                                      _vm.submitClicked
                                        ? _c(
                                            "a-alert",
                                            {
                                              key:
                                                "alertContainer-" +
                                                _vm.$i18n.locale,
                                              staticClass: "mb-2",
                                              attrs: {
                                                message:
                                                  _vm.$t("message.error"),
                                                showIcon: "",
                                                type: "error",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: {
                                                    slot: "description",
                                                  },
                                                  slot: "description",
                                                },
                                                _vm._l(
                                                  _vm.$validator.errors.items,
                                                  function (err) {
                                                    return _c("div", [
                                                      _c("span", [
                                                        _vm._v(_vm._s(err.msg)),
                                                      ]),
                                                    ])
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-form",
                                        {
                                          staticClass:
                                            "d-flex flex-column justify-content-center",
                                          on: {
                                            submit: function ($event) {
                                              $event.preventDefault()
                                              return _vm.handleSaveOsrForm.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { md: "12" } },
                                                [
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        [
                                                          _c("MultiContent", {
                                                            ref: "MultiContent",
                                                            model: {
                                                              value:
                                                                _vm.osrInitialObject,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.osrInitialObject =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "osrInitialObject",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            md: "12 mt-2",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "b-button",
                                                            {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.loading,
                                                                type: "submit",
                                                                variant:
                                                                  "primary",
                                                              },
                                                            },
                                                            [
                                                              !_vm.loading
                                                                ? [
                                                                    !_vm.editMode
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "message.save"
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "message.update"
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ]
                                                                : [
                                                                    _c(
                                                                      "font-awesome-icon",
                                                                      {
                                                                        attrs: {
                                                                          icon: "spinner",
                                                                          spin: "",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                            ],
                                                            2
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-button",
                                                            {
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.cancelForm()
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "message.cancel"
                                                                    )
                                                                  )
                                                                ),
                                                              ],
                                                            ],
                                                            2
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("a-col"),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }